import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { AuthUiHelperService } from 'src/app/auth/auth.ui.helper.service';
import { LoginService } from 'src/app/auth/login/login.service';
import { NebulrAnonymousTranslationService } from 'src/app/shared/services/nebulr-anonymous-translation.service';

@Component({
  selector: 'nblocks-mfa-reset',
  templateUrl: './mfa-reset.page.html',
  styleUrls: ['./mfa-reset.page.css']
})
export class MfaResetPage {

  error = false;
  loading = false;
  param = {};
  privacyPolicyUrl: string;
  
  constructor(
    private readonly loginService: LoginService,
    private readonly navCtrl: NavController,
    private readonly authUiHelperService: AuthUiHelperService,
    private readonly nebulrAnonymousTranslationService: NebulrAnonymousTranslationService, // Needed for translations to work properly
  ) {
    this.param = this.authUiHelperService.getYear();
    this.privacyPolicyUrl = this.authUiHelperService.getPrivacyPolicyUrl();
  }

  public async submit(form: NgForm): Promise<void> {
    try {
      this.loading = true;
      this.error = false;
      
      const { backupCode } = form.value;
      await this.loginService.resetUserMfaSetup(backupCode);
      this.navCtrl.navigateRoot('auth/mfa/setup');
    } catch (error) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  public async handleKeyUp(e: KeyboardEvent, form: NgForm): Promise<void> {
    if (e.key === 'Enter' && form.valid) {
      this.submit(form);
    }
  }

}
